import React from 'react'

interface Props {
  lang: 'zh' | 'en'
  category?: string
}

interface HeroContent {
  title: string
  image: string
  alt: string
}

const HERO_MAP: Record<string, { zh: HeroContent; en: HeroContent }> = {
  beans: {
    zh: {
      title: '咖啡豆',
      image: 'https://file.lumi.new/p373839333138763776/SPF2016947172312682496.png',
      alt: 'ONGU Studio 精品咖啡豆',
    },
    en: {
      title: 'Beans',
      image: 'https://file.lumi.new/p373839333138763776/SPF2016947172312682496.png',
      alt: 'ONGU Studio specialty coffee beans',
    },
  },
  dripbag: {
    zh: {
      title: '濾掛',
      image: 'https://images.pexels.com/photos/4109743/pexels-photo-4109743.jpeg?auto=compress&cs=tinysrgb&w=1920',
      alt: 'ONGU Studio 濾掛咖啡',
    },
    en: {
      title: 'Drip Bag',
      image: 'https://images.pexels.com/photos/4109743/pexels-photo-4109743.jpeg?auto=compress&cs=tinysrgb&w=1920',
      alt: 'ONGU Studio drip bag coffee',
    },
  },
  gift: {
    zh: {
      title: '禮盒',
      image: 'https://images.pexels.com/photos/4350057/pexels-photo-4350057.jpeg?auto=compress&cs=tinysrgb&w=1920',
      alt: 'ONGU Studio 咖啡禮盒',
    },
    en: {
      title: 'Gift Box',
      image: 'https://images.pexels.com/photos/4350057/pexels-photo-4350057.jpeg?auto=compress&cs=tinysrgb&w=1920',
      alt: 'ONGU Studio coffee gift box',
    },
  },
  gear: {
    zh: {
      title: '器材',
      image: 'https://images.pexels.com/photos/3020919/pexels-photo-3020919.jpeg?auto=compress&cs=tinysrgb&w=1920',
      alt: 'ONGU Studio 咖啡器材',
    },
    en: {
      title: 'Gear',
      image: 'https://images.pexels.com/photos/3020919/pexels-photo-3020919.jpeg?auto=compress&cs=tinysrgb&w=1920',
      alt: 'ONGU Studio coffee gear',
    },
  },
  all: {
    zh: {
      title: 'Shop',
      image: 'https://file.lumi.new/p373839333138763776/SPF2016947172312682496.png',
      alt: 'ONGU Studio 商店',
    },
    en: {
      title: 'Shop',
      image: 'https://file.lumi.new/p373839333138763776/SPF2016947172312682496.png',
      alt: 'ONGU Studio shop',
    },
  },
}

/**
 * ShopHeroV2
 * One image, one big word — aligns with BusinessHeroV2 / StoreHeroV2.
 * Sits below the solid HeaderV2 per the V2 site rule.
 * Hero content adapts to category (beans / dripbag / gift / gear / all).
 */
const ShopHeroV2: React.FC<Props> = ({ lang, category = 'beans' }) => {
  const key = (category || 'beans').toLowerCase()
  const entry = HERO_MAP[key] || HERO_MAP.beans
  const { title, image, alt } = entry[lang]

  return (
    <section className='relative h-[60vh] min-h-[420px] w-full overflow-hidden bg-black'>
      <div className='absolute inset-0'>
        <img
          src={image}
          alt={alt}
          className='h-full w-full object-cover'
        />
        <div className='absolute inset-0 bg-black/30' />
        <div className='absolute inset-x-0 bottom-0 h-48 bg-gradient-to-t from-black/55 to-transparent' />
      </div>

      <div className='relative z-10 mx-auto flex h-full max-w-[1600px] items-end px-6 pb-12 md:px-10 md:pb-16'>
        <h1
          className='text-white'
          style={{
            fontFamily: "'EB Garamond', 'Noto Serif TC', serif",
            fontWeight: 400,
            fontSize: 'clamp(2.25rem, 5vw, 4rem)',
            letterSpacing: '0.02em',
            lineHeight: 1.1,
          }}
        >
          {title}
        </h1>
      </div>
    </section>
  )
}

export default ShopHeroV2
